import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from '@/app/App';
import '@/shared/config/i18n';
import '@/app/styles/globals.scss';
import { resetSessionForActivationLink } from '@/entities/Auth';
import { syncSsoTokenFromUrl } from '@/shared/lib/auth/syncSsoTokenFromUrl';

syncSsoTokenFromUrl();
resetSessionForActivationLink();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
);
